__turbopack_context__.v({
  "column": "SikkerhetStillinger-module__vv0UvW__column",
  "flexContainer": "SikkerhetStillinger-module__vv0UvW__flexContainer",
  "row": "SikkerhetStillinger-module__vv0UvW__row",
  "stillingPanel": "SikkerhetStillinger-module__vv0UvW__stillingPanel",
  "style": "SikkerhetStillinger-module__vv0UvW__style",
  "tekst": "SikkerhetStillinger-module__vv0UvW__tekst",
});
